<div
    #aboveBlackLine
    class="st-rich-text-editor__above-black-line bottom"
    [froalaEditor]="options"
    [froalaModel]="content()"
    (froalaModelChange)="onContentChange($event)"></div>
<div class="st-rich-text-editor__black-line">
    <div
        class="st-rich-text-editor__black-line__arrow-controls"
        [class.circle-container]="currentPosition() === BlackLinePositionEnum.MIDDLE">
        <div [class.circle-arrows-wrapper]="currentPosition() === BlackLinePositionEnum.MIDDLE">
            <button
                mat-icon-button
                class="st-rich-text-editor__black-line__arrow-controls__arrow-btn"
                [class.st-rich-text-editor__black-line__arrow-controls__arrow-btn--colored]="currentPosition() === BlackLinePositionEnum.BOTTOM && contentBelowBlackLine()"
                [class.st-rich-text-editor__black-line__arrow-controls__arrow-btn--hidden]="currentPosition() === BlackLinePositionEnum.TOP"
                (click)="onArrowUpClick()">
                <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_up</mat-icon>
            </button>
            <button
                mat-icon-button
                class="st-rich-text-editor__black-line__arrow-controls__arrow-btn"
                [class.st-rich-text-editor__black-line__arrow-controls__arrow-btn--hidden]="currentPosition() === BlackLinePositionEnum.BOTTOM"
                (click)="onArrowDownClick()">
                <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_down</mat-icon>
            </button>
        </div>
    </div>
</div>
<div
    #belowBlackLine
    class="st-rich-text-editor__bellow-black-line bottom"
    [froalaEditor]="optionsBelowBlackLine"
    [froalaModel]="contentBelowBlackLine()"
    (froalaModelChange)="onContentChange($event)"></div>
